import React from "react";
import "./PrivacySecurity.scss";

const PrivacySecurity = () => {
    return (
        <div className="privacy-security">
            <h1>Aspire Privacy Policy</h1>
            <p>
                <strong>Last Updated:</strong> June 9, 2025
            </p>

            <p>
                This Privacy Policy explains how Aspire (“we”, “us”, or “our”) collects, uses, and
                protects your personal data when you use our platform at{" "}
                <a href="https://aspire.onemax.org">aspire.onemax.org</a>. Aspire is committed to
                respecting your privacy and complying with applicable data protection laws.
            </p>

            <h2>1. Information We Collect</h2>
            <h3>a. Information You Provide</h3>
            <ul>
                <li>Name, email, phone number</li>
                <li>Profile data (e.g. education, employment, skills)</li>
                <li>Messages, posts, comments, uploaded files</li>
                <li>Event registrations and RSVP responses</li>
            </ul>

            <h3>b. Information Automatically Collected</h3>
            <ul>
                <li>IP address and browser type</li>
                <li>Device data (OS, language settings)</li>
                <li>Usage data (pages visited, interactions)</li>
                <li>Cookies and similar technologies</li>
            </ul>

            <h3>c. Third-Party Sources</h3>
            <p>We may collect data from:</p>
            <ul>
                <li>Partners or affiliates (e.g. MAX)</li>
                <li>Publicly available data (e.g. professional websites)</li>
            </ul>

            <h2>2. How We Use Your Information</h2>
            <ul>
                <li>Provide, personalize, and improve Aspire’s services</li>
                <li>Suggest connections, content, and events</li>
                <li>Communicate with you about updates and features</li>
                <li>Ensure platform security and prevent misuse</li>
                <li>Analyze usage trends for product improvements</li>
                <li>Comply with legal obligations</li>
            </ul>

            <h2>3. Sharing of Information</h2>
            <ul>
                <li>With other users (based on your privacy settings)</li>
                <li>With service providers who help operate Aspire (e.g. hosting, analytics)</li>
                <li>As required by law or to enforce our Terms of Service</li>
                <li>With your consent or at your direction</li>
            </ul>
            <p>
                <strong>We do not sell your personal data.</strong>
            </p>

            <h2>4. Cookies & Tracking</h2>
            <p>We use cookies to:</p>
            <ul>
                <li>Keep you logged in</li>
                <li>Remember your preferences</li>
                <li>Measure platform performance</li>
            </ul>
            <p>You can control cookie settings through your browser.</p>

            <h2>5. Your Rights & Choices</h2>
            <p>Depending on your location, you may have the right to:</p>
            <ul>
                <li>Access or download your data</li>
                <li>Correct inaccurate information</li>
                <li>Delete your account or data</li>
                <li>Object to or restrict certain processing</li>
            </ul>
            <p>
                To make a request, contact us at: <strong>aspire@maxgala.com</strong>
            </p>

            <h2>6. Data Retention</h2>
            <p>
                We retain your data as long as your account is active or as needed to provide
                services. We may retain certain data even after account closure if required for
                legal, security, or operational purposes.
            </p>

            <h2>7. Data Security</h2>
            <p>
                We use industry-standard security measures to protect your information. However, no
                system is 100% secure. Please use strong passwords and report suspicious activity.
            </p>

            <h2>8. International Transfers</h2>
            <p>
                If you access Aspire from outside Canada, your data may be transferred to servers
                located in Canada or other jurisdictions with different data protection laws.
            </p>

            <h2>9. Changes to This Policy</h2>
            <p>
                We may update this Privacy Policy from time to time. Major changes will be
                communicated to you through the platform or by email.
            </p>

            <h2>10. Contact Us</h2>
            <p>For questions or concerns, contact:</p>
            <p>
                <strong>Aspire Privacy Team</strong>
                <br />
                Email: <strong>aspire@maxgala.com</strong>
            </p>
        </div>
    );
};

export default PrivacySecurity;
